module.exports = __webpack_public_path__ + "7c11f7909aa70b7f27927e8a1400abbc.svg";